import { Box, SxProps, Theme } from '@mui/material';
import { CandidateProfileList } from 'modules/candidate-profile/components/CandidateProfileList';
import {
  CandidateListTab,
  useCandidateListStore
} from 'modules/candidate-profile/stores/useCandidateListStore';
import { CandidateProfileTalentPoolTable } from 'modules/candidate-profile/tables/CandidateProfileTalentPoolTable';
import { CandidateProfileListType } from 'modules/candidate-profile/types/CandidateProfileListProps';

const getTabPanelSx = (isActive: boolean): SxProps<Theme> => ({
  display: isActive ? 'block' : 'none'
});

export const CandidateProfileListPage: React.FC = () => {
  const activeTab = useCandidateListStore((state) => state.activeTab);

  return (
    <>
      <Box sx={getTabPanelSx(activeTab === CandidateListTab.CANDIDATES)}>
        <CandidateProfileList type={CandidateProfileListType.CANDIDATES_LIST} />
      </Box>
      <Box sx={getTabPanelSx(activeTab === CandidateListTab.TALENT_LISTS)}>
        <CandidateProfileTalentPoolTable
          type={CandidateProfileListType.CANDIDATES_LIST}
        />
      </Box>
    </>
  );
};
